import * as React from 'react';
import glamorous from 'glamorous';
import { padding, shade } from 'polished';
import { hover } from 'app/utils/cssUtils';

const ConfirmButton = glamorous(({ type = 'button', ...rest }) => <button type={type} {...rest} />)(
  {
    borderRadius: 5,
    color: 'white',
    display: 'flex',
    fontSize: '1.25rem',
    margin: '0 auto',
    minHeight: '3rem',
    minWidth: '11rem',
    ...padding('0.5rem', '3rem'),
    textTransform: 'uppercase',
    transition: 'background-color 0.2s',
  },
  props => ({
    backgroundColor: props.disabled ? props.theme.color.basis5 : props.theme.color.basis2,
    ...hover({
      backgroundColor: props.disabled
        ? props.theme.color.basis5
        : shade(0.75, props.theme.color.basis4),
    }),
  }),
);

export default ConfirmButton;
